import { Route, Routes } from "react-router";
import { getRoutesArray } from './config';

export default function AppRoutes() {
    const routesArray = getRoutesArray();

    return (
        <Routes>
            {routesArray.map((route) => (
                <Route
                    key={route.key}
                    path={route.path}
                    element={route.render()}
                />
            ))}
        </Routes>
    )
}